<template>
  <b-card
    :title="title"
    img-alt="Image"
    img-top
    tag="article"
    style="max-width: 20rem; border-radius: 15px; position: relative"
    class="mb-2"
  >
    <b-img
      fluid
      :src="urlDisplay"
      @click="handleGoToURLLocation"
      alt="Image 2"
    />
    <b-card-text>
      <br />
      <b-link
          style="position: absolute; bottom: 0;"
          @click="handleGoToSeeMoreLocation">
        See more
      </b-link>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: "Faves_Products_Card",
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: "Pick up where you left off"
    },
    urlDisplay: {
      type: String,
      default:
        "https://firebasestorage.googleapis.com/v0/b/derriana.appspot.com/o/derriana_faves_imgs%2Fimages.jpg_hpRicebSIlbAVWD_1704586888837?alt=media&token=b19b7709-79c9-40ab-8207-e6731b174ac8"
    },
    urlSeeMore: {
      type: String,
      default:
        "https://firebasestorage.googleapis.com/v0/b/derriana.appspot.com/o/derriana_faves_imgs%2Fimages.jpg_hpRicebSIlbAVWD_1704586888837?alt=media&token=b19b7709-79c9-40ab-8207-e6731b174ac8"
    },
    urlLocation: {
      type: String,
      default:
        "https://firebasestorage.googleapis.com/v0/b/derriana.appspot.com/o/derriana_faves_imgs%2Fimages.jpg_hpRicebSIlbAVWD_1704586888837?alt=media&token=b19b7709-79c9-40ab-8207-e6731b174ac8"
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleGoToURLLocation() {
      if (this.urlLocation) window.open(this.urlLocation, "_blank");
    },
    handleGoToSeeMoreLocation() {
      if (this.urlSeeMore) window.open(this.urlSeeMore, "_blank");
    }
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 150,
        height: 150,
        class: "m1"
      },
      faveData:
        this.faveEntity && this.faveEntity.form ? this.faveEntity.form : null
    };
  }
};
</script>
